/**
 * @name HandleMessage
 * @param message: string
 * @param variables: string[]
 * @returns React.JSX.Element
 * @example
 * <HandleMessage message="{0}. O **seu {1}** está cadastrado em um **formato inválido**." variables={["João", "e-mail"]} />
 * <span>João. O <b>seu e-mail</b> está cadastrado em um <b>formato inválido</b></span>
 */
import React, {Fragment} from 'react';
import {HandleMessageProps} from './types';
import {replaceVariables, splitBoldParts} from './utils';

const HandleMessage = ({message, variables}: HandleMessageProps) => {
	const formatted = replaceVariables(message, variables);
	const parts = splitBoldParts(formatted);
	return (
		<Fragment>
			{parts.map((part, idx) =>
				part.bold ? <b key={`${part.text}-${idx}`}>{part.text}</b> : part.text,
			)}
		</Fragment>
	);
};

export {HandleMessage};
